import { 
    SET_ADMIN_FINANCE_FEES_LIST,
    DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE,
    DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE
  } from './constants';
    
export const displayFinancialFeesList = (data) => ({
  type: SET_ADMIN_FINANCE_FEES_LIST,
  payload: data
});

export const displayDefaultTechFeeModalVisibility = visible => ({
  type: DISPLAY_GROUP_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE,
  payload: visible
});

export const displayTournamentTechFeeModalVisibility = visible => ({
  type: DISPLAY_TOURNAMENT_TECH_FEE_MODAL_FOR_DEFAULT_TECH_FEE,
  payload: visible
});


// WEBPACK FOOTER //
// ./src/features/finance/fees/actionTypes.js